
<div class="val-simple-image val-flex-conteneur">
  <div class="val-flex-1"></div>
  <div class="val-flex-conteneur val-flex-colonne">
    <div class="val-flex-1"></div>
    <img  [src]="src"
          [ngStyle]="{'width': width > 0 ? width + 'px' : 'auto', 'height': height > 0 ? height + 'px' : 'auto'}"/>
    <div class="val-flex-1"></div>
  </div>
  <div class="val-flex-1"></div>
</div>

